<!-- PAGE CONTENT WRAPPER -->
<div class="block">
  <form class="form-horizontal" id="myForm" role="form" novalidate>
    <div class="reports-form-container">
      <!--stage-->
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Stage</mat-label>
        <mat-select id="stage" name="stage" [(ngModel)]="transaction.stage">
          <mat-option value="undefined" disabled>Select Stage</mat-option>
          <mat-option value="Growout">Growout</mat-option>
          <mat-option value="Preparatory">Preparatory</mat-option>
          <mat-option value="PostHarvest">PostHarvest</mat-option>
        </mat-select>
      </mat-form-field>
      <!--date field-->
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="transactionDateControl" placeholder="Choose date" autocomplete="off" readonly
        [max]="maxDate"/>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <!--preparing itemids data-->
    <div class="row">
      <div class="row eachcard" *ngFor="let row of items; let i = index">
        <div>
            <span class="add-item-icon"><img src="assets/images/New_Icons/plus-icon.svg"
                                             (click)="addNewItemButton()"></span>
          <span><i class="fa fa-minus minusicon" *ngIf="i >= 1" (click)="removeItemCard(i)"></i></span>
        </div>
        <div class="reports-form-container purchase-item-block">
          <!--item-->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Item</mat-label>
            <mat-select id="item" name="item" [(ngModel)]="row.item_id" [ngModelOptions]="{standalone: true}" (selectionChange)="getItemIdsUomData(i); getBusinessItemByItemId(i);">
              <mat-option value="undefined" disabled>Select Item</mat-option>
              <mat-option *ngFor="let itemmaster of inventoryItems" [value]="itemmaster.id">
                {{ (itemmaster?.item_name) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <p style="color: red;" *ngIf="(itemMasters && itemMasters.length == 0 && paramsbusinessId !='')">
            No item available for this business</p>
          <!--quantity-->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Quantity</mat-label>
            <input matInput id="quantity" name="quantity" [(ngModel)]="row.quantity" [ngModelOptions]="{standalone: true}" (input)="totalAmount();" (keypress)="numberValidation($event)" type="text" autocomplete="off" placeholder=""/>
          </mat-form-field>
          <!--uom -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>UOM</mat-label>
            <mat-select id="uom_id" name="uom" [(ngModel)]="row.uom_id" [ngModelOptions]="{standalone: true}">
              <mat-option value="undefined" disabled>Select UOM</mat-option>
              <mat-option *ngFor="let unit of row.itemUom" [value]="unit.id">
                {{ (unit?.name) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!--unit cost-->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Unit Cost</mat-label>
            <input matInput id="unit_cost" name="unitcost" [(ngModel)]="row.unit_cost" [ngModelOptions]="{standalone: true}" (input)="totalAmount();" (keypress)="numberValidation($event)" type="text" autocomplete="off" placeholder=""/>
          </mat-form-field>
          <!--GST cost-->
          <mat-form-field appearance="outline" class="w-100" *ngIf="['EMPLOYEE', 'Farmer', 'Business Admin'].includes(loginPersonType)">
            <mat-label>Enter GST(%)</mat-label>
            <input matInput id="gst" name="gstcost" (input)="totalAmount();" (keypress)="numberValidation($event)" [(ngModel)]="row.gst_percent" [ngModelOptions]="{standalone: true}" type="text" autocomplete="off" placeholder=" "/>
          </mat-form-field>
          <!--Value-->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Value (Includes GST if provided)</mat-label>
            <input matInput id="unitValueField" value="{{ row.quantity && row.unit_cost && row.gst_percent ?
                    ((row.quantity * row.unit_cost * (1 + row.gst_percent / 100)).toFixed(2)) : ((row.quantity * row.unit_cost).toFixed(2)) }}" type="text" autocomplete="off" placeholder="" />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" style="padding: 20px 30px 10px 30px;">
      <p>Total Amount (Includes GST if provided): <span>{{ totalamount ? totalamount : 0 }}</span></p>
    </div>
    <!--amount paid block-->
    <div class="col-lg-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Enter Paid Amount</mat-label>
        <input matInput id="amountpaid" name="amountpaid" [(ngModel)]="paymentTransaction.paid_amount" [ngModelOptions]="{standalone: true}" (keypress)="numberValidation($event)" type="text" autocomplete="off" placeholder=""/>
      </mat-form-field>
    </div>
    <!--vendor field-->
    <div class="col-lg-4">
      <mat-form-field appearance="outline" class="w-100 ">
        <mat-label>Vendor Name</mat-label>
        <!-- Searchable input + autocomplete -->
        <input matInput id="vendors" type="text" autocomplete="off" placeholder="Search vendor" [formControl]="vendorCtrl"
               [matAutocomplete]="vendorAuto" (click)="vendorsDropdownOpen = true" (keyup)="filterVendors($event)" (focus)="filteredVendorNames = vendors"/>
        <mat-autocomplete #vendorAuto="matAutocomplete" [displayWith]="displayVendor" (optionSelected)="selectVendorOption($event.option.value)">
          <mat-option *ngFor="let option of filteredVendorNames" [value]="option"> {{ option.name }} </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <!--invoice number-->
    <div class="col-lg-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Invoice Number</mat-label>
        <input matInput id="invoicenumber" name="invoice" [(ngModel)]="paymentTransaction.invoice_number" type="text" autocomplete="off" placeholder=""/>
      </mat-form-field>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <div class="form-field">
              <textarea type="text" name="desc" class="form-control" [(ngModel)]="transaction.notes" autocomplete="off"
                        placeholder=""></textarea>
          <label>Description</label>
        </div>
      </div>
      <div class="col-lg-4">
        <!-- Wrap both file input & image preview in one row -->
        <div class="file-upload-row">
          <!-- File Upload Box -->
          <div class="file-container">
            <div class="file-name-div">
              <p class="file-title">Upload invoice</p>
              <span class="inventory-file-name">Upload file</span>
            </div>
            <div class="file-upload-div">
              <input type="file" name="file" id="imageUpload" (change)="fileupload($event)" style="display: none;"
                     autocomplete="off" accept="image/jpeg, image/jpg, image/png, image/gif" />
              <span class="inventory-browse-file" (click)="browseFile()">Browse</span>
            </div>
          </div>
          <!-- Image Preview -->
          <ng-container *ngIf="selectedbase64file">
            <div class="image-preview-container">
              <div class="image-wrapper">
                <img [src]="selectedbase64file" alt="Preview" />
                <img src="assets/images/New_Icons/delete-icon.svg" class="delete_icon" (click)="remove()" />
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="buttons-div" style="padding: 60px 20px 0px 20px;">
        <div class="transactions-button-container">
          <button class="transaction-submit-button" (click)="inventoryTransaction()"
                  [disabled]="submitButtonDisabled">
            <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
            <span class="text">Submit</span>
          </button>
        </div>
        <div class="transactions-button-container">
          <button class="transaction-close-button" (click)="clearTransactionData($event)">
            <span class="reset-icon"><img src="../../../../../../assets/images/New_Icons/reset-only-icon.svg"></span>
            <span class="text">Reset</span>
          </button>
        </div>
      </div>
    </div>
    <!-- display data when pass the particular id -->
    <div class="panel-body table-responsive transactiontable" *ngIf="issubmitted">
      <table class="table">
        <thead class="thead-light">
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Business Name</th>
          <th scope="col">Location</th>
          <th scope="col" *ngIf="paymentTransaction && paymentTransaction.Vendor && paymentTransaction.Vendor">Vendor
            Name
          </th>
          <th scope="col">Item Name</th>
          <th scope="col">Opening Stock</th>
          <th scope="col">Transfer/Return</th>
          <th scope="col">On Hand</th>
          <th scope="col">Total Consumption</th>
          <th scope="col">Value</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let list of latestTransactionData && latestTransactionData.transactionResult; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ latestTransactionData && latestTransactionData.business_name }}</td>
          <td>{{ latestTransactionData && latestTransactionData.farm_location }}</td>
          <td
            *ngIf="paymentTransaction && paymentTransaction.Vendor && paymentTransaction.Vendor">{{ paymentTransaction && paymentTransaction.Vendor && paymentTransaction.Vendor.name }}
          </td>
          <td>{{ list && list.onHand[0] && list.onHand[0].ItemMaster && list.onHand[0].ItemMaster.item_name }}</td>
          <td>{{ (list && list.onHand[0] && list.onHand[0].opening_stock) | currencyFormat }} {{ list && list.onHand[0] && list.onHand[0].UOMMaster && list.onHand[0].UOMMaster.name }}</td>
          <td>{{ (list && list.onHand[0] && list.onHand[0].transfer) | currencyFormat }} {{ list && list.onHand[0] && list.onHand[0].UOMMaster && list.onHand[0].UOMMaster.name }}</td>
          <td>{{ (list && list.onHand[0] && list.onHand[0].onHand) | currencyFormat }} {{ list && list.onHand[0] && list.onHand[0].UOMMaster && list.onHand[0].UOMMaster.name }}</td>
          <td>{{ (list && list.totalConsumption) | currencyFormat }} {{ list && list.onHand[0] && list.onHand[0].UOMMaster && list.onHand[0].UOMMaster.name }}</td>
          <td
            *ngIf="(list && list.onHand[0] && list.onHand[0].ItemMaster && list.onHand[0].ItemMaster.isInventory == false)">{{ ((list && list.onHand[0] && list.onHand[0].value) >= 0 ? (((list && latestTransactionData.onHand[0] && latestTransactionData.onHand[0].value) * -1)| currencyFormat) : (((list && list.onHand[0] && list.onHand[0].value) * -1) |  currencyFormat)) }}
          </td>
          <td
            *ngIf="(list && list.onHand[0] && list.onHand[0].ItemMaster && list.onHand[0].ItemMaster.isInventory == true)">{{ ((list && list.onHand[0] && list.onHand[0].value) |  currencyFormat) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </form>
</div>
